export const CHAT_COMPOSER_PLACEHOLDER: string = 'Describe what you want Solo to do...';

export function buildChatGreeting(firstName?: string | null): string {
  return firstName ? `Hey ${firstName}, how can I help your business today?` : 'How can I help your business today?';
}
